<template>
  <a-card :bordered='false'>
      <div class="outBox"  >
    <div class="insideBox s_flex_ali" >
      <p >分类功能只便于运营人员管理礼品库，如需要在  <router-link to="/integralShop/index">积分商城</router-link>前端进行商品分类展示，请到 <router-link to="/integralShop/giftExchange/giftCate">积分商城分类</router-link>操作。</p>
    </div>
  </div>
    <div class='mb25 m-t-25 s_flex_ali'>
      <span class='mr15'>
        <a-button type="primary" v-has:createGiftCateOne="visibleToggle">
          新增一级分类
        </a-button>
      </span>
    </div>
     <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='cateList'>
        <template v-slot:action="{ record }">
                  <a  href="javascript:;" v-has:editGiftCateOne="()=>{group=JSON.parse(JSON.stringify(record));visible=true}" class="m-r-5">修改</a>

               <a v-has:delGiftCateOne="()=>del(record.id)" href="javascript:;">删除</a>
        </template>
      </a-table>
  </a-card>
  <!-- 添加分类 -->
  <a-modal  :keyboard="false" title="分类管理" centered v-model:visible="visible" :confirm-loading="confirmLoading" @ok="handleOk" destroyOnClose>
    <a-form ref="groupForm" :model="group" :label-col="{span:4}" :wrapper-col="{span:20}" help='限8个字符'>
      <a-form-item ref="name" label="分组名称" name="name" :rules="[{ required: true, message: '请输入分类名称' },{ max: 20, message: '分组名称不超过20个字符' }]">
        <a-input v-model:value="group.name" />
      </a-form-item>
      <a-form-item ref="id" label="id" name="id" hidden>
        <a-input v-model:value="group.id" />
      </a-form-item>
      <a-form-item ref="p_id" label="p_id" name="p_id" hidden>
        <a-input v-model:value="group.p_id" />
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import { iscode } from "@/utils/app";
import { onMounted, reactive, toRefs, ref, watch } from "vue";
import {
  getGiftCate,
  createGiftCate,
  updateGiftCate,
  deleteGiftCate
  
} from "@/api/product.js";
import { DownOutlined } from "@ant-design/icons-vue";
import { Modal } from 'ant-design-vue';
export default {
  name: "product",
  setup(props) {
    const state = reactive({
      cateList: [],
      visible: false,
      confirmLoading: false,
      listLoading:false
    });
      let columns = [
      {
        title: '分组名称',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: '礼品数量',
        dataIndex: 'total',
        key: 'total',
      },
      {
        title: '操作',
        key: 'action',
        slots: { customRender: 'action' },
      },
    ];
    const initData = async () => {
      state.listLoading=true
      let result = await getGiftCate().then((res) => res.data);
      state.listLoading=false
      state.cateList = result.data;
    };
    // 弹出表单
    const visibleToggle=()=>{
      group.value ={ name: "", id: null};
      state.visible=true
    }
    // 定义分类表单绑定数据
    const group = ref({ name: "", id: null});
    // 定义分类表单ref
    const groupForm = ref();
    // 提交
    const handleOk = () => {
      groupForm.value
        .validate()
        .then(async (res) => {
          state.confirmLoading = true;
          var result;
          if (!res.id ) {
            result = await createGiftCate(res);
          }  else {
            // 修改分类
            result = await updateGiftCate(res.id, res);
          }
            state.confirmLoading = false;
          if (iscode(result.data, true)) {
            state.visible = false;
            initData();
             groupForm.value.resetFields();
          }
        })
        .catch((error) => {});
    };
    // 删除
    const del=(id)=>{
      Modal.confirm({
        centered:true,
        content: "删除后将无法恢复，您确定要删除吗？",
        onOk: async () => {
          let res = await deleteGiftCate(id).then((res) => res.data);
          if (iscode(res, true)) {
            initData();
          }
        },
      });
    }
    onMounted(() => {
      initData();
    });
    return {
      ...toRefs(state),
      handleOk,
      group,
      groupForm,
      del,
      visibleToggle,
      columns
    };
  },
};
</script>

